/** Canonical public SEO slug per internal corridor key. */
const INTERNAL_TO_SEO: Record<string, string> = {
  "hyderabad-vijayawada": "hyderabad-to-vijayawada-carpool",
  "hyderabad-guntur": "hyderabad-to-guntur-carpool",
  "hyderabad-khammam": "hyderabad-to-khammam-carpool",
  "hyderabad-bangalore": "hyderabad-to-bangalore-carpool",
  "vijayawada-visakhapatnam": "vijayawada-to-visakhapatnam-carpool",
  "vijayawada-guntur": "vijayawada-to-guntur-carpool",
  "vijayawada-nellore": "vijayawada-to-nellore-carpool",
  "nellore-chennai": "nellore-to-chennai-carpool",
  "nellore-tirupati": "nellore-to-tirupati-carpool",
  "chennai-tirupati": "chennai-to-tirupati-carpool",
  "bangalore-chittoor": "bangalore-to-chittoor-carpool",
};

/** Reverse-direction public slugs → same internal corridor (display cities swapped in CorridorPage). */
const REVERSE_SEO_SLUGS: Record<string, string> = {
  "vijayawada-to-hyderabad-carpool": "hyderabad-vijayawada",
  "guntur-to-hyderabad-carpool": "hyderabad-guntur",
  "chennai-to-nellore-carpool": "nellore-chennai",
  "tirupati-to-chennai-carpool": "chennai-tirupati",
  "tirupati-to-nellore-carpool": "nellore-tirupati",
  "visakhapatnam-to-vijayawada-carpool": "vijayawada-visakhapatnam",
  "guntur-to-vijayawada-carpool": "vijayawada-guntur",
  "nellore-to-vijayawada-carpool": "vijayawada-nellore",
  "khammam-to-hyderabad-carpool": "hyderabad-khammam",
  "bangalore-to-hyderabad-carpool": "hyderabad-bangalore",
  "chittoor-to-bangalore-carpool": "bangalore-chittoor",
};

const SEO_TO_INTERNAL: Record<string, string> = {
  ...Object.fromEntries(Object.entries(INTERNAL_TO_SEO).map(([internal, seo]) => [seo, internal])),
  ...REVERSE_SEO_SLUGS,
  // Legacy short slugs (pre-SEO URLs)
  "hyderabad-vijayawada": "hyderabad-vijayawada",
  "hyderabad-guntur": "hyderabad-guntur",
  "hyderabad-khammam": "hyderabad-khammam",
  "hyderabad-bangalore": "hyderabad-bangalore",
  "vijayawada-visakhapatnam": "vijayawada-visakhapatnam",
  "vijayawada-guntur": "vijayawada-guntur",
  "vijayawada-nellore": "vijayawada-nellore",
  "nellore-chennai": "nellore-chennai",
  "nellore-tirupati": "nellore-tirupati",
  "chennai-tirupati": "chennai-tirupati",
  "bangalore-chittoor": "bangalore-chittoor",
};

export function resolveCorridorSlug(slug: string): string {
  return SEO_TO_INTERNAL[slug] ?? slug;
}

export function toPublicCorridorSlug(internalSlug: string): string {
  return INTERNAL_TO_SEO[internalSlug] ?? internalSlug;
}

export function isReversePublicCorridorSlug(publicSlug: string): boolean {
  return publicSlug in REVERSE_SEO_SLUGS;
}

export function listPublicCorridorSlugs(): string[] {
  return [
    ...Object.values(INTERNAL_TO_SEO),
    ...Object.keys(REVERSE_SEO_SLUGS),
  ];
}
